import { render, staticRenderFns } from "./ResultPaypal.vue?vue&type=template&id=6443bf19&"
import script from "./ResultPaypal.vue?vue&type=script&lang=js&"
export * from "./ResultPaypal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports